import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { themeColors } from '@styles/theme';
import { useTheme } from '@context/themeContext';

type DialogComponentProps = {
    openDialog: boolean;
    onCloseFn: (event: any, reason?: 'backdropClick' | 'escapeKeyDown') => void;
    dialogTitle: string;
    children?: React.ReactNode;
};

const DialogComponent = ({
    openDialog,
    onCloseFn,
    dialogTitle = '',
    children,
}: DialogComponentProps) => {
    const { theme } = useTheme();
    const { t } = useTranslation();

    const backgroundColor = theme === 'light' ? themeColors.white : themeColors.grey4;
    const color = theme === 'light' ? themeColors.navyBlue : themeColors.white;

    return (
        <Dialog
            open={openDialog}
            onClose={onCloseFn}
            className="MuiDialog-root"
            slotProps={{
                paper: {
                    sx: {
                        color,
                        backgroundColor,
                        minWidth: '400px',
                    },
                },
            }}
        >
            <DialogTitle sx={{}}>{dialogTitle}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button onClick={onCloseFn}>{t('action-menu.dialog-cancel-btn')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogComponent;
